import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Navbar from "../components/Navbar/Navbar";
import { apiCall } from "../api/apiCall";
import { ExpenseReport } from "../models/expense_report";
import { User } from "../models/user";
import UpdateExpenseReportStatusCard from "./UpdateExpenseReportStatusCard";
import { useTranslation } from "../i18n/UseTranslation";
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

function UpdateExpenseReportStatusPage() {
  const { uuid } = useParams<{ uuid: string }>();
  const { t } = useTranslation();

  const [isAuthReady, setIsAuthReady] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      setIsAuthReady(true);
    });
    return () => unsubscribe();
  }, []);

  const { data: currentUser } = useQuery<User, Error>({
    queryKey: ["current-user"],
    queryFn: async () => apiCall<User>(`/users/me`, { method: "GET" }),
    enabled: isAuthReady && isAuthenticated,
  });

  const {
    data: expenseReport,
    isLoading,
    isError,
    error,
  } = useQuery<ExpenseReport, Error>({
    queryKey: ["expense-report-status", uuid],
    queryFn: async () =>
      apiCall<ExpenseReport>(`/expense-reports/${uuid}`, { method: "GET" }),
    enabled: isAuthReady && isAuthenticated && !!uuid,
  });

  if (isLoading || !isAuthReady) {
    return (
      <>
        <Navbar />
        <p style={{ paddingTop: "90px", textAlign: "center" }}>
          {t.updateExpenseStatus?.loading || "Loading..."}
        </p>
      </>
    );
  }

  if (isError || !expenseReport) {
    return (
      <>
        <Navbar />
        <p style={{ paddingTop: "90px", color: "red", textAlign: "center" }}>
          {t.updateExpenseStatus?.error || "Error: "}
          {error?.message ||
            t.updateExpenseStatus?.notFound ||
            "Expense report not found"}
        </p>
      </>
    );
  }

  const userRoleName = currentUser?.role?.name?.toLowerCase() || "";

  return (
    <>
      <Navbar />
      <UpdateExpenseReportStatusCard
        expenseReport={expenseReport}
        userRole={userRoleName}
      />
    </>
  );
}

export default UpdateExpenseReportStatusPage;
